import { ScrollIcon } from "@phosphor-icons/react/dist/csr/Scroll";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
} from "@volca/ui/components/ui/empty";
import { PageContainer } from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { useBusiness } from "@/core/business";
import { useGetMyUser } from "@/user/query";
import { EditorWorkspace } from "./editor-workspace";

const PayrollEditorPage = () => {
  const { businessId } = useBusiness();
  const { data: user, isPending, isError, refetch } = useGetMyUser();
  return (
    <PageContainer variant="workspace" className="max-w-none gap-0 p-0 md:px-0">
      <h1 className="sr-only">Payroll rules</h1>
      {/* Three different situations, not one. A user still loading, and a user
          that failed to load, were both reported as "select a business", which
          is advice about something the reader has already done and cannot act
          on again. */}
      {isPending ? (
        <p>Loading…</p>
      ) : isError || !user ? (
        <Stack gap={4} align="start">
          <p role="alert">Your account could not load. Try again.</p>
          <Button size="xs" variant="outline" onClick={() => void refetch()}>
            Try again
          </Button>
        </Stack>
      ) : !businessId ? (
        <Empty className={emptyStateVariants({ layout: "panel" })}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <ScrollIcon aria-hidden />
            </EmptyMedia>
            <EmptyDescription>
              Select a business to view payroll rules.
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <EditorWorkspace
          key={`${user.id}:${businessId}`}
          userId={user.id}
          businessId={businessId}
        />
      )}
    </PageContainer>
  );
};

export default PayrollEditorPage;
